export interface Workspace {
  id: string;
  name: string;
  createdAt: string;
  postsCount?: number;
  assetsCount?: number;
  logoUrl?: string;
  logoScale?: number; // 0.1-3.0, default 1.0
  logoOffsetX?: number; // -50 to 50, percentage shift
  logoOffsetY?: number; // -50 to 50, percentage shift
  selectedTemplateIds?: string[] | null;
}

export interface CreateWorkspaceRequest {
  name: string;
  logoUrl?: string;
}

export interface UpdateWorkspaceRequest {
  name: string;
}

// ─── Scan & Create from URL types ────────────────────────────────────────────

export interface ClassifiedImage {
  url: string;
  category: 'logo' | 'photo';
  score: number;
  source: string; // 'img-tag', 'favicon', 'og:image', 'json-ld', etc.
}

export interface ScanUrlResult {
  url: string;
  suggestedName: string;
  images: ClassifiedImage[];
  brandColors: string[];
  brandInfo: Record<string, unknown>;
}

export interface CreateFromScanRequest {
  name: string;
  url: string;
  logoUrl?: string;
  backgroundImageUrls?: string[];
  brandInfo: Record<string, unknown>;
}
